module.exports = __webpack_public_path__ + "img/evaluate_admin_2.d8374215.jpg";